<div class="peer-thank-you-page">
  <div class="top-section">
    <div class="brand-bar">
      <span class="brand-name">GradPilots</span>
    </div>
    <div class="hero-card">
      <div class="status-icon">
        <i class="pi pi-check"></i>
      </div>
      <h1>Your form has been received.</h1>
      <p>Thank you for taking the time to fill this in.</p>
    </div>
  </div>

  <div class="bottom-section">
    <div class="message-panel">
      <p class="headline">We appreciate you taking the time to apply.</p>
      <p>A confirmation email has been sent to the address you provided.</p>
      <a class="website-link" href="https://gradpilots.com" target="_blank" rel="noreferrer">gradpilots.com</a>
    </div>

    <button class="home-button" (click)="navigateHome()">Back to Home</button>
  </div>
</div>
